import { Component, AfterViewInit, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavController, NavParams, App } from 'ionic-angular';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { PosAppVersion } from '../../app/models/PosAppVersion';
import { HttpErrorResponse } from '@angular/common/http';
import { ModalDirective, BsDatepickerConfig } from 'ngx-bootstrap';
import { NgForm } from '@angular/forms';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { ConfigService } from '../../providers/config/config.service';
import { Config } from '../../providers/config';
import { Storage } from '../../../node_modules/@ionic/storage';

@Component({
  selector: 'page-pos-app',
  templateUrl: 'pos-app.html',
})
export class PosAppPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild('appVersionModal')
  private appVersionModal: ModalDirective;

  @ViewChild('appVersionForm')
  private appVersionForm: NgForm;

  private navControllerService: NavControllerService;
  private currentConfiguration: Config;
  public bsConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();

  private pageName: string = 'page-pos-app';
  private posAppVersion = new PosAppVersion();
  private currentPosAppVersion = new PosAppVersion();
  private editedMinAllowedVersionExpiration: Date;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private app: App,
    private configService: ConfigService,
    private backendService: PaytronBackendService,
    private storage: Storage
  ) {
    this.navControllerService = new NavControllerService(app, storage);
    this.currentConfiguration = this.configService.getConfiguration();
  }

  ngOnInit(): void {
    this.bsConfig = this.currentConfiguration.datepickerConfig;
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  ionViewWillEnter() {
    this.loadPosAppInfo();
  }

  ionViewDidEnter() {}

  private loadPosAppInfo() {
    this.backendService.getPosAppVersion().subscribe(
      (data: PosAppVersion) => {
        this.posAppVersion = data;
      },
      (err: HttpErrorResponse) => {}
    );
  }

  addPosAppVersion() {
    this.currentPosAppVersion = new PosAppVersion();
    this.appVersionForm.resetForm();
    this.showAppVersionModal();
  }

  editPosAppVersion() {
    this.currentPosAppVersion = this.posAppVersion;
    if (this.currentPosAppVersion.minAllowedVersionExpiration) {
      this.editedMinAllowedVersionExpiration = new Date(
        new Date(this.currentPosAppVersion.minAllowedVersionExpiration).toDateString() + ' 00:00:00'
      );
    } else {
      this.editedMinAllowedVersionExpiration = null;
    }
    this.showAppVersionModal();
  }

  submitAppVersion(btnEvent: HTMLButtonElement) {
    btnEvent.disabled = true;
    this.currentPosAppVersion.minAllowedVersionExpiration = this.editedMinAllowedVersionExpiration;
    this.backendService
      .saveOrUpdatePosAppVersion(this.currentPosAppVersion)
      .subscribe(
        (data) => {
          this.loadPosAppInfo();
        },
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        btnEvent.disabled = false;
        this.closeAppVersionModal();
      });
  }

  showAppVersionModal() {
    this.appVersionModal.show();
  }

  closeAppVersionModal() {
    this.loadPosAppInfo();
    this.appVersionModal.hide();
  }

  showPosPage() {
    this.navControllerService.showPosPage();
  }

  showZonesPage() {
    this.navControllerService.showZonesPage();
  }
}



// WEBPACK FOOTER //
// ./src/pages/pos-app/pos-app.ts